import { ProgressBar } from '@crehana/compass.ui/progress-bar';

type TWorkedHoursCellProps = {
  workedHours: string;
  scheduledHours: string;
  percentage: number;
};

export const WorkedHoursCell = ({
  workedHours,
  scheduledHours,
  percentage,
}: TWorkedHoursCellProps) => {
  const clampedPercentage = Math.min(percentage, 100);

  return (
    <div className="tw-flex tw-flex-col tw-gap-0.4">
      <span className="tw-cds-font-subtitle-01">{workedHours}</span>
      <div className="tw-w-full tw-h-0.6 tw-cds-bg-secondary tw-rounded-full tw-overflow-hidden">
        <ProgressBar value={clampedPercentage} size="sm" />
      </div>
      <div className="tw-flex tw-justify-between">
        <span className="tw-cds-font-body-01 tw-cds-text-subtle">0 h</span>
        <span className="tw-cds-font-body-01 tw-cds-text-subtle">
          {scheduledHours}
        </span>
      </div>
    </div>
  );
};
